export interface Category {
  label: string;
  url: string;
  image: string;
}

const CATEGORIES_DATA: Category[] = [
  {
    label: 'Gaming',
    url: 'sr-artworks/gaming',
    image: 'gaming',
  },
  {
    label: 'Movies',
    url: 'posters/movies',
    image: 'movies',
  },
  {
    label: 'Manga & Anime',
    url: 'sr-artworks/manga?category=Anime%20%26%20Manga',
    image: 'manga_anime',
  },
  {
    label: 'Fantasy',
    url: 'sr-artworks/fantasy',
    image: 'fantasy',
  },
  {
    label: 'TV Shows',
    url: 'posters/tv-shows',
    image: 'tv_shows',
  },
  {
    label: 'Sport',
    url: 'posters/sports',
    image: 'sport',
  },
  {
    label: 'Music',
    url: 'posters/music',
    image: 'music',
  },
  {
    label: 'Nature',
    url: 'posters/nature',
    image: 'nature',
  },
  {
    label: 'Travel',
    url: 'sr-artworks/travel',
    image: 'travel',
  },
  {
    label: 'Cars',
    url: 'sr-artworks/cars',
    image: 'cars',
  },
  {
    label: 'Animals',
    url: 'sr-artworks/animals-nature?category=Animals',
    image: 'animals',
  },
  {
    label: 'Space',
    url: 'posters/space',
    image: 'space',
  },
];

export default CATEGORIES_DATA;
